import React, { useEffect, useState } from "react"
import { Col, ControlLabel, FormGroup, FormControl, HelpBlock } from "react-bootstrap"
import { propEq } from "ramda"
import { localized, maxNameLength, maxCommandLineParameterLength, maxFilePathLength } from "js/includes/common/utils"
import ArchitectureSelect from "js/includes/components/scripting/ArchitectureSelect"
import { getCredentialReactSelectOptions } from "./common/credentials"
import Select from "react-select"
import { useMounted } from "js/includes/common/hooks"

export default function RunApplication({ onChange, validateForm, validation, values }) {
  const [credentialOptions, setCredentialOptions] = useState([])
  const { appName, cmdLineParameters, exePath, runAs, supportedArchitecture } = values
  const mounted = useMounted()

  useEffect(() => {
    const fetchAndSetCredentials = async () => {
      const credentials = await getCredentialReactSelectOptions("Windows")
      mounted.current && setCredentialOptions(credentials)
    }
    fetchAndSetCredentials()
  }, [mounted, setCredentialOptions])

  return (
    <>
      <FormGroup
        className="m-sm m-b-lg text-align-left"
        validationState={validation.success.supportedArchitecture === false ? "error" : null}
      >
        <Col xs={4} componentClass={ControlLabel}>
          {localized("editors.policy.actions.architecture")}
        </Col>
        <Col xs={8}>
          <ArchitectureSelect supportedArchitecture={supportedArchitecture} onChange={onChange} />
          <HelpBlock className="invalid position-absolute m-t-none">
            {validation.success.supportedArchitecture === false && validation.message.supportedArchitecture}
          </HelpBlock>
        </Col>
      </FormGroup>
      <FormGroup
        className="m-sm m-b-lg text-align-left"
        validationState={validation.success.appName === false ? "error" : null}
      >
        <Col xs={4} componentClass={ControlLabel}>
          {localized("general.name")}
        </Col>
        <Col xs={8}>
          <FormControl
            {...{
              maxLength: maxNameLength,
              onBlur: () => validateForm(["appName"]),
              onChange: e => onChange("appName", e.target.value),
              placeholder: localized("editors.policy.actions.applicationName"),
              value: appName || "",
            }}
          />
          <HelpBlock className="invalid position-absolute m-t-none">
            {validation.success.appName === false && validation.message.appName}
          </HelpBlock>
        </Col>
      </FormGroup>
      <FormGroup
        className="m-sm m-b-lg text-align-left"
        validationState={validation.success.exePath === false ? "error" : null}
      >
        <Col xs={4} componentClass={ControlLabel}>
          {localized("general.path")}
        </Col>
        <Col xs={8}>
          <FormControl
            {...{
              maxLength: maxFilePathLength,
              onBlur: () => validateForm(["exePath"]),
              onChange: e => onChange("exePath", e.target.value),
              placeholder: localized("editors.policy.actions.pathToExe"),
              value: exePath || "",
            }}
          />
          <HelpBlock className="invalid position-absolute m-t-none">
            {validation.success.exePath === false && validation.message.exePath}
          </HelpBlock>
        </Col>
      </FormGroup>
      <FormGroup className="m-sm m-b-lg text-align-left">
        <Col xs={4} componentClass={ControlLabel}>
          {localized("editors.policy.actions.parameters")}
        </Col>
        <Col xs={8}>
          <FormControl
            {...{
              maxLength: maxCommandLineParameterLength,
              onChange: e => onChange("cmdLineParameters", e.target.value),
              placeholder: localized("editors.policy.actions.commandLineParameters"),
              value: cmdLineParameters || "",
            }}
          />
        </Col>
      </FormGroup>
      <FormGroup
        className="m-sm m-b-lg text-align-left"
        validationState={validation.success.runAs === false ? "error" : null}
      >
        <Col xs={4} componentClass={ControlLabel}>
          {localized("editors.policy.actions.runAs")}
        </Col>
        <Col xs={8}>
          <Select
            id="runAs"
            onChange={selection => onChange("runAs", selection.value)}
            options={credentialOptions}
            value={credentialOptions.find(propEq("value", runAs))}
          />
          <HelpBlock className="invalid position-absolute m-t-none">
            {validation.success.runAs === false && validation.message.runAs}
          </HelpBlock>
        </Col>
      </FormGroup>
    </>
  )
}
